import { Typography } from "@mui/material";
import React from "react";
import UseCaseCard from "./UseCaseCard";
import { USE_CASES } from "../DeployWizard.consts";
import { WizardContainer, UseCaseGrid } from "../DeployWizard.styles";

const StepUseCase = ({ selectedUseCase, onSelectUseCase }) => (
  <WizardContainer>
    <Typography variant="h6" gutterBottom>
      What are you testing?
    </Typography>
    <Typography variant="body2" color="text.600" sx={{ mb: 3 }}>
      Select the scenario that best describes what you need to deploy:
    </Typography>
    <UseCaseGrid>
      {Object.values(USE_CASES).map((useCase) => (
        <UseCaseCard
          key={useCase.id}
          testId={`use-case-${useCase.id}`}
          label={useCase.label}
          description={useCase.description}
          selected={selectedUseCase === useCase.id}
          onClick={() => onSelectUseCase(useCase.id)}
        />
      ))}
    </UseCaseGrid>
  </WizardContainer>
);

export default StepUseCase;
